import React, { Component } from 'react';
import { InputNumber } from 'antd';
import "./index.scss";

class App extends Component {
    render() {
        const { text, onChange, name } = this.props;
        return (
            <InputNumber
                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                precision={2}
                defaultValue={Number(text || "0") || ""}
                className="title-InputNumber"
                placeholder="请输入"
                onBlur={(e) => {
                    let value = Number(e.target.value.replace(/,/g, '') || '0');
                    value = Number(value.toFixed(2));
                    onChange(name, value)
                }}
            />
        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-5/InputNumber.js